import { ReactElement, useEffect } from "react";
import { LogLevel, logPost } from "../../api/controllers/logController/logController";

const benignErrors = ["Script error", "ResizeObserver loop"];

export const ErrorBoundary = (props: { children: ReactElement }) => {
  const handleOnError = (ev: ErrorEvent) => {
    const message = ev.message;
    const isBenignError = benignErrors.some((pattern) => message.includes(pattern));
    if (isBenignError) {
      return;
    }

    const errorInfo = {
      message,
      filename: ev.filename,
      line: ev.lineno,
      column: ev.colno,
      stack: ev.error?.stack,
    };
    logPost({ message: JSON.stringify(errorInfo), level: LogLevel.Critical });
  };

  window.addEventListener("error", handleOnError);

  useEffect(() => {
    return () => {
      window.removeEventListener("error", handleOnError);
    };
  }, []);

  return props.children;
};

export default ErrorBoundary;
